export const userCancelReason = "Canceled by user";
export const launchRewriteModeReason = "Launched rewrite mode";
